import HomeLayout from '@/layouts/Home.vue'
import CreateCalendarPeriodsGroup from './views/CreateCalendarPeriodsGroup.vue'
import CalendarPeriodsDetails from './views/CalendarPeriodsDetails.vue'
import ListCalendarPeriodsGroups from '@/modules/calendarPeriods/views/ListCalendarPeriodsGroups.vue'

export const calendarPeriodsRoutes = [
  {
    path: '/payrollsConfig/:id/calendarPeriods',
    name: 'calendarPeriods',
    component: ListCalendarPeriodsGroups,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/calendarPeriods/add',
    name: 'calendarPeriods/add',
    component: CreateCalendarPeriodsGroup,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/calendarPeriods/detail/:calendarPeriodId',
    name: 'calendarPeriods/detail',
    component: CalendarPeriodsDetails,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
]
